import React from "react";
import {StoreLocation, StoreProductTypeTerm} from "../types/StoreItem";
import {useSelector} from "react-redux";
import {RootState} from "../store";

interface InfoWindowContentProps {
    storeName: string;
    storeLocation: StoreLocation;
    storePhone: string | null;
    storeProductTypes: StoreProductTypeTerm[];
    storeSearchDistanceInMiles: number;
}

const InfoWindowContent: React.FC<InfoWindowContentProps> = (props) => {

    const distance = {
        miles: Math.round(props.storeSearchDistanceInMiles * 100) / 100,
        kilometers: Math.round((props.storeSearchDistanceInMiles * 1.60934) * 100) / 100
    };

    const searchCenterCoords = useSelector((state: RootState) => state.storeSearchCircleSlice.storeSearchCenterCoords);

    return (
        <div className="blj-store-locator-info-window-content">
            <div className="blj-store-locator-info-window-content__header">
                <h4 className="blj-store-locator-info-window-content__store-name">
                    {props.storeName}
                </h4>
                {distance.miles > 0 && distance.kilometers > 0 && (
                    <span className="blj-store-locator-info-window-content__store-distance">
                        {`${distance.miles} miles (${distance.kilometers} km) away`}
                    </span>
                )}
                <address className="blj-store-locator-info-window-content__store-address">
                    {props.storeLocation.address}
                </address>
            </div>
            <div className="blj-store-locator-info-window-content__body">
                {props.storePhone && (
                    <span className="blj-store-locator-info-window-content__store-phone">
                        Phone:&nbsp;
                        <a href={`tel:${props.storePhone}`}>
                            {props.storePhone}
                        </a>
                    </span>
                )}

                {props.storeProductTypes.length > 0 && (
                    <span className="blj-store-locator-info-window-content__store-product-types">
                        {props.storeProductTypes.map((productType) => {
                            if (productType !== props.storeProductTypes[props.storeProductTypes.length - 1]) {
                                return productType.name + ", ";
                            } else {
                                return productType.name;
                            }
                        })}
                    </span>
                )}

                {searchCenterCoords && (
                    <a className="blj-store-locator-info-window-content__get-directions-link"
                       href={`https://www.google.com/maps/dir/?api=1&origin=${searchCenterCoords.lat},${searchCenterCoords.lng}&destination=${props.storeLocation.lat},${props.storeLocation.lng}`}
                       target="_blank"
                       rel="nofollow"
                    >
                        Get directions
                    </a>
                )}
            </div>
        </div>
    );
}

export default InfoWindowContent;